import {
  IconActivity,
  IconBook2,
  IconClockBolt,
  IconFileText,
  IconSchool,
  IconUserBolt,
} from "@tabler/icons-react";

/**
 * The icon each configurable resource is shown with, in navigation and on
 * the copilot's proposal cards.
 */
export const resourceTypeIcons = {
  playbook: IconBook2,
  signal: IconActivity,
  automation: IconClockBolt,
  voiceAgent: IconUserBolt,
  training: IconSchool,
  knowledgeBaseDocument: IconFileText,
} as const;
